<p-dialog
  [visible]="dialog.visible()"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '34rem', maxWidth: '92vw' }"
  styleClass="branduals-dialog compliance-check-dialog"
  [header]="'compliance.check.title' | translate">

  @if (loading()) {
    <div class="check-loading">
      <fa-duotone-icon [icon]="faSpinnerThird" class="fa-spin"></fa-duotone-icon>
      {{ 'compliance.check.checking' | translate }}
    </div>
  } @else if (result(); as r) {
    @if (hasRules()) {
      <p class="dialog-subtitle">
        {{ 'compliance.check.summary' | translate: { rules: r.rulesEvaluated, violations: r.violationCount } }}
        @if (r.overallScore !== null) {
          · {{ 'compliance.check.overallScore' | translate: { score: r.overallScore } }}
        }
      </p>

      <div class="check-rows">
        @for (row of r.results; track row.ruleRecordId) {
          <div class="check-row">
            <span class="check-rule">{{ 'compliance.rules.types.' + row.ruleType | translate }}</span>
            <div class="check-outcome">
              @if (row.skipReason) {
                <span class="check-skip" [title]="skipReasonKey(row.skipReason) | translate">{{ skipReasonKey(row.skipReason) | translate }}</span>
              }
              <app-status-badge
                [label]="'compliance.check.status.' + row.status | translate"
                [tone]="statusTone(row.status)"
                shape="compact" />
            </div>
          </div>
        }
      </div>

      <div class="check-footer muted">
        {{ 'compliance.check.checkedAt' | translate }} {{ r.checkedAt | displayDate:'dateTime' }}
        · {{ 'compliance.check.advisory' | translate }}
      </div>
    } @else {
      <span class="muted no-rules">{{ 'compliance.check.noRules' | translate }}</span>
    }
  }
</p-dialog>
